require.ensure(['scrollmagic-core', 'scrollmagic-gsap'], () => {
  const ScrollMagic = require('scrollmagic-core');
  require('scrollmagic-gsap');

  const $listFadeInItem = $('.js-fade-in-area .js-fade-in');
  // const $CarouselFadeInItem = $('.js-fade-in-carousel .js-fade-in');
  if ($listFadeInItem.length) {
    const fadeSection = new ScrollMagic.Controller();
    $listFadeInItem.each((i, element) => {
      new ScrollMagic.Scene({ triggerElement: element, duration: 500, offset: -300 })
        .setTween(element, { opacity: 1 })
        .addTo(fadeSection);
    });
  }

  // if ($CarouselFadeInItem.length) {
  //   const fadeSection2 = new ScrollMagic.Controller();
  //
  //   new ScrollMagic.Scene({ triggerElement: '.js-fade-in-carousel' })
  //     .setTween($CarouselFadeInItem, { opacity: 1 })
  //     .addTo(fadeSection2);
  // }
});
